import { render, staticRenderFns } from "./LessonMemosDialog.vue?vue&type=template&id=00b540d5&scoped=true&"
import script from "./LessonMemosDialog.vue?vue&type=script&lang=js&"
export * from "./LessonMemosDialog.vue?vue&type=script&lang=js&"
import style0 from "./LessonMemosDialog.vue?vue&type=style&index=0&id=00b540d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b540d5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
installComponents(component, {VDivider,VFileInput})
